import { useApp } from "../state/AppState";

/**
 * Ce qui se passe après le paiement, dit **avant** de le demander.
 *
 * Le parcours d'achat annonce déjà « la rédaction prend jusqu'à neuf minutes »
 * — mais il l'annonce une fois qu'on a payé. Les deux pages de vente, elles, ne
 * disaient rien : ni le délai, ni comment on récupère le document, ni qu'aucun
 * compte n'est nécessaire.
 *
 * Les deux coûts sont réels et opposés. Avant l'achat, une attente non annoncée
 * est un motif de renoncement : la personne ne sait pas si elle en a pour dix
 * secondes ou pour une journée, et elle ne prend pas le risque. Après l'achat,
 * c'est un motif de remboursement : quelqu'un qui a payé 3 000 F et regarde une
 * page tourner sans savoir combien de temps conclut que rien ne vient.
 *
 * Le composant est partagé plutôt que recopié : la page salariée et la page
 * dirigeante font la même promesse, et une promesse en double dérive.
 */
export function ApresPaiement({ minutes = 9 }: { minutes?: number }) {
  const { contactCourriel } = useApp();
  return (
    <div className="apres reveal">
      <b>Après le paiement</b>
      <ol>
        <li>
          Votre rapport est <b>rédigé pour vous</b>, sur ce que vous venez de déclarer, en
          quelques minutes — {minutes} au plus.
        </li>
        <li>
          Il s'ouvre <b>sur cette page</b>, en PDF. Rien à installer, aucun compte à créer, aucun
          numéro à retenir. Ce que l'opérateur de paiement vous a demandé pour son reçu reste chez
          lui : STRATERA ne le conserve pas.
        </li>
        <li>
          Vous pouvez fermer la fenêtre : le bouton <b>Récupérer mon rapport</b> vous y ramène
          depuis cet appareil.
        </li>
        <li>
          S'il n'arrive pas, le remboursement est dû — sans justification, en un bouton ou par
          courriel à <a href={`mailto:${contactCourriel}`}>{contactCourriel}</a>.
        </li>
      </ol>
    </div>
  );
}
